/* =========================================================================
   assets/drawers.js
   Menu, Sacola, Concierge e demais painéis laterais.
   Um único componente <fea-drawer> + gatilhos [data-drawer-open].
   Substitui MenuDrawer / CartDrawer / ConciergeDrawer do React.
   ========================================================================= */

class FeaDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.fea-drawer__panel');
    this.previouslyFocused = null;

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]') || event.target.classList.contains('fea-drawer__overlay')) {
        this.close();
      }
    });

    this.onKeydown = this.onKeydown.bind(this);
  }

  open() {
    this.previouslyFocused = document.activeElement;
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.addEventListener('keydown', this.onKeydown);
    requestAnimationFrame(() => {
      const first = this.focusables()[0];
      if (first) first.focus();
    });
    this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    document.removeEventListener('keydown', this.onKeydown);
    if (this.previouslyFocused) this.previouslyFocused.focus();
    this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
  }

  focusables() {
    return Array.from(
      this.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((el) => el.offsetParent !== null);
  }

  /* Esc fecha, Tab fica preso dentro do painel (focus trap). */
  onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = this.focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}
customElements.define('fea-drawer', FeaDrawer);

/* Gatilhos globais: <button data-drawer-open="menu-drawer"> */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drawer-open]');
  if (!trigger) return;
  const drawer = document.getElementById(trigger.dataset.drawerOpen);
  if (!drawer) return;
  event.preventDefault();
  drawer.open();
});

/* Acordeão de coleções dentro do menu (sem <details>, para animar) */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.fea-menu__toggle');
  if (!toggle) return;
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  const panel = document.getElementById(toggle.getAttribute('aria-controls'));
  if (panel) panel.hidden = expanded;
});
